/* NC error trap — POSTs cart/add.js failures + window.onerror + unhandledrejection
 * to the worker's /cart-error endpoint. See worker/src/index.js::handleCartError
 * and worker/migrations/0002_cart_errors.sql. Privacy: structural fields only —
 * no PII, no form values.
 *
 * Created in response to Derek Pierce (derek@brixpartners.com) reporting a
 * Shopify "Required parameter missing or invalid: items" error with no
 * server-side surface to diagnose. The trap catches storefront-side failures;
 * Shopify-hosted checkout pages (/checkouts/cn/...) are NOT covered — those
 * run on infrastructure we don't control.
 */
(function () {
  var ENDPOINT = 'https://downloads-api.nightingale.com/cart-error';

  // De-dup window: same {source,error_text,page_path} within 10s = one report.
  // Cart-add failures often arrive in retry bursts; without this a single
  // misbehaving page can hit the rate-limit ceiling in seconds.
  var DEDUP_WINDOW_MS = 10000;
  var recent = Object.create(null);

  function shouldReport(key) {
    var now = Date.now();
    var last = recent[key] || 0;
    if (now - last < DEDUP_WINDOW_MS) return false;
    recent[key] = now;
    // Drop old entries on every check (cheap bound on memory).
    for (var k in recent) {
      if (now - recent[k] > DEDUP_WINDOW_MS * 6) delete recent[k];
    }
    return true;
  }

  function safeString(v) {
    if (v == null) return null;
    try { return String(v); } catch (_) { return null; }
  }

  function post(payload) {
    var key = (payload.error_source || '') + '|' + (payload.error_text || '') + '|' + (payload.page_path || '');
    if (!shouldReport(key)) return;
    try {
      // keepalive:true so navigation away (e.g., checkout click) doesn't kill
      // the fetch. Matches account-recover.js interceptor convention.
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit',
      }).catch(function () { /* swallow — trap must never throw */ });
    } catch (_) { /* swallow */ }
  }

  // Public API for explicit cart-error reports (called by product-form.js).
  // Schema mirrors the worker handler's truncation contract — strings should
  // already be reasonable length but the worker truncates defensively.
  function reportCartError(info) {
    info = info || {};
    post({
      error_source: 'cart_add',
      error_text: safeString(info.error_text),
      http_status: Number.isInteger(info.http_status) ? info.http_status : null,
      request_path: safeString(info.request_path) || '/cart/add.js',
      page_path: location.pathname,
      product_id: safeString(info.product_id),
      variant_id: safeString(info.variant_id),
    });
  }

  function reportManual(info) {
    info = info || {};
    post({
      error_source: 'manual',
      error_text: safeString(info.error_text),
      http_status: Number.isInteger(info.http_status) ? info.http_status : null,
      request_path: safeString(info.request_path),
      page_path: location.pathname,
      product_id: safeString(info.product_id),
      variant_id: safeString(info.variant_id),
    });
  }

  window.NCErrorTrap = {
    reportCartError: reportCartError,
    reportManual: reportManual,
  };

  // Global JS error catcher — captures errors anywhere on a storefront page,
  // including any third-party script that throws. Sample-rate is implicit via
  // the dedup window above.
  window.addEventListener('error', function (ev) {
    if (!ev) return;
    var msg = (ev.message || (ev.error && ev.error.message) || 'error').toString();
    post({
      error_source: 'window_onerror',
      error_text: msg,
      page_path: location.pathname,
      js_filename: safeString(ev.filename),
      js_line: Number.isInteger(ev.lineno) ? ev.lineno : null,
      js_col: Number.isInteger(ev.colno) ? ev.colno : null,
    });
  });

  // Unhandled Promise rejections — most fetch/.then errors land here.
  window.addEventListener('unhandledrejection', function (ev) {
    if (!ev) return;
    var reason = ev.reason;
    var msg;
    if (reason && typeof reason === 'object') {
      msg = reason.message || JSON.stringify(reason).slice(0, 400);
    } else {
      msg = safeString(reason) || 'unhandled_rejection';
    }
    post({
      error_source: 'unhandled_rejection',
      error_text: msg,
      page_path: location.pathname,
    });
  });
})();
